<!--
 * @Author: 陈大仙人
 * @Date: 2024-01-10 17:02:42
 * @LastEditors: 陈大仙人
 * @LastEditTime: 2024-01-11 11:51:15
 * @FilePath: /akx-pc-main/src/login/views/ad.vue
-->
<template>
  <div v-if="adList[index]" style="font-size: 0; width: 100%;">
    <img v-for="(item, i) in adList[index].content" style="width: 100%;" :src="item" :index="i" alt="" @click="handle(i)">
    <ad-tip :visable.sync="visable" :info="adList[index]"></ad-tip>
  </div>
</template>
<script>
import adList from '../ad';
import adTip from '../components/ad-tip.vue'
export default {
  components: {
    adTip,
  },
  data() {
    return {
      visable: false,
      adList,
      index: -1,
    }
  },
  created() {
    this.index = this.$route.query.index / 1;
  },
  methods: {
    handle(i) {
      this.adList[this.index].event && this.adList[this.index].event(i, this);
    }
  },
}
</script>